//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { social } from '~/utils/social';
export default {
  name: 'ContactBox',
  props: {
    title: { type: String, default: '' },
  },
  data() {
    return {
      company: '德仁管理顧問有限公司',
      location: '台北市內湖區瑞光路335號4樓23室',
      email: 'official@step1ne.com',
      tel: '02-6605-7111',
      social: social,
      mapPath: 'https://www.google.com/maps/embed/v1/place',
      mapKey: 'AIzaSyBqxNUmDZpLAf5gR69KR8b1KwaaVClQncs',
    };
  },
  computed: {
    mapUrl() {
      if (!this.location) return '';
      const mapTaget = this.location.replace(/^近|\d樓$/g, '');
      return `${this.mapPath}?key=${this.mapKey}&q=${mapTaget}`;
    },
    noData() {
      return !this.location && !this.email && !this.tel;
    },
  },
};
